import { IProfile } from "@interfaces/Core/Account/profile";
import useApiCall from "@hooks/Shared/useApiCall";

const useGetProfile = (uuid: string) =>
  useApiCall<IProfile>({
    url: "/account/" + uuid,
  });

export default useGetProfile;
